import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';

export type MplsNextHopColumnValue = {
  action: string;
  intName: string;
  ip: string;
  label: string;
  vrf: string;
};

export const formatMplsNextHopValue = (value: MplsNextHopColumnValue) => {
  if (value.action === 'no' && value.label === null) {
    return `${value.ip ?? ''} ${value.intName ?? ''} ${value.action ?? ''} label${value.vrf ?? ''}`.trim();
  }
  return `${value.ip ?? ''} ${value.intName ?? ''} ${value.action ?? ''}${value.label ?? ''}${value.vrf ?? ''}`.trim();
};

export type TableColumnFormatMplsNextHop<TRow> = {
  type: 'mplsNextHop';
  field: KeyOfType<TRow, MplsNextHopColumnValue | null>;
};

export const createMplsNextHopColumn: {
  <TRow>(
    config: TableDataColumnConfig<TRow, MplsNextHopColumnValue | null> & {
      array?: false;
    },
  ): TableColumnBase<TRow, TableColumnFormatMplsNextHop<TRow>>;
  <TRow>(
    config: TableDataColumnConfig<TRow, MplsNextHopColumnValue[] | null> & {
      array: true;
    },
  ): TableColumnBase<TRow, TableColumnFormatMplsNextHop<TRow>>;
} = <TRow>(
  config: TableDataColumnConfig<TRow, MplsNextHopColumnValue | null>,
): TableColumnBase<TRow, TableColumnFormatMplsNextHop<TRow>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'mplsNextHop',
    field: config.key,
  },
  csvStringDependencies: [config.key],
  webDependencies: [config.key],
  toCsvString: (row) => {
    const val = getValueFromKeyOfType(row, config.key);

    return val
      ? formatValueToCsvString(
          val as MplsNextHopColumnValue | MplsNextHopColumnValue[],
          formatMplsNextHopValue,
        )
      : '';
  },
  filter: createDefaultFilter(config.filter, undefined),
});
